import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity } from '@adornis/baseql/decorators/entity.js';
import { Field } from '@adornis/baseql/decorators/field.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import type { DebitorEntity } from '../../debitor-numbers/entities/DebitorEntity.js';
import { LegacyDebitorNumber } from '../../debitor-numbers/entities/LegacyDebitorNumber.js';

@Entity()
export class VirtualAccountingEntity extends MongoEntity implements DebitorEntity {
  public static override _class = 'VirtualAccountingEntity';
  public static override _collectionName = 'virtual-accounting-entities';

  @Field(() => String)
  debitorennummer: Maybe<string>;

  /** set instead of the debitorennummer when the booked number is a Kreditor (`isKreditorenNummer`), like on a person */
  @Field(() => String)
  kreditorenNr: Maybe<string>;

  @Field(() => [LegacyDebitorNumber], { default: v => v ?? [] })
  legacyDebitorNumbers: Maybe<LegacyDebitorNumber[]>;
}
